/**
 * Formats a number of seconds as a compact human-friendly duration:
 *   < 60s        → `"42s"`
 *   < 1h         → `"15m"`
 *   < 1d         → `"2h 15m"`
 *   ≥ 1d        → `"3d 4h 30m"`
 * Returns `"—"` for null/undefined/NaN/negative inputs.
 *
 * Used by the "Avg Time" KPI/columns across multiple ManualActions surfaces
 * (Withdrawals APV, AllManualActions APV) so the BE-canonical `*_seconds`
 * fields render identically everywhere.
 */
export const formatDurationSeconds = (seconds: unknown): string => {
  if (seconds == null) return "—";
  const n = Number(seconds);
  if (!Number.isFinite(n) || n < 0) return "—";

  const total = Math.round(n);
  if (total < 60) return `${total}s`;

  const days = Math.floor(total / 86400);
  const hours = Math.floor((total % 86400) / 3600);
  const mins = Math.floor((total % 3600) / 60);

  const parts: string[] = [];
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0) parts.push(`${hours}h`);
  if (mins > 0 || parts.length === 0) parts.push(`${mins}m`);
  return parts.join(" ");
};
